import { useMemo } from 'react';
import styles from './SegmentedControl.module.scss.js';
import { SegmentedControlContext } from './SegmentedControlContext.js';
import { jsx } from 'react/jsx-runtime';
import { useControllableState } from '../util/useControllableState.js';
import { HorizontalScrollable } from '../scrollable/HorizontalScrollable.js';

function SegmentedControl(_ref) {
  let {
    children,
    defaultSelected,
    selected,
    variant = 'default',
    onSelect
  } = _ref;
  const [internalSelected, internalOnSelect] = useControllableState(selected, defaultSelected, onSelect);
  const contextValue = useMemo(() => ({
    selected: internalSelected,
    onSelect: internalOnSelect,
    variant
  }), [internalSelected, internalOnSelect, variant]);
  return /*#__PURE__*/jsx(SegmentedControlContext.Provider, {
    value: contextValue,
    children: /*#__PURE__*/jsx(HorizontalScrollable, {
      viewportClassName: styles.control,
      viewportRole: "tablist",
      children: children
    })
  });
}

export { SegmentedControl };
